/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";
import { termsEditorActionEditor } from "../../terms/actionEditor";

export function registerMenus(dc: IEditor): void {
	const menuSvc = dc.get("menuService");

	menuSvc.registerMenuItem("main.create", {
		id: "action",
		label: termsEditorActionEditor.mainMenu.sectionCreate.action.label,
		tooltip: termsEditorActionEditor.mainMenu.sectionCreate.action.tooltip,
		icon: "mdi/motion-play",
		flags: [ "primary" ],
		order: 20,
		commandId: "actionEditor.create.open"
	});
}
